<div *ngIf="checkoutDisabled">
    <div class="row">
        <div class="col-md-12">
            <div
                style="min-height: 300px"
                *ngIf="maintenanceMessage"
            >
                <h3>System Maintenance</h3>
                <p>The checkout page is currently down for maintenance until <strong>{{maintenanceMessage}}</strong>. Please come back later.</p>
                <p>Thank you for your patience.</p>
            </div>
        </div>
    </div>
</div>

<div
    class="page"
    *ngIf="!checkoutDisabled && userOrderAddress"
>
    <app-step-progress [steps]="steps"></app-step-progress>
    <app-page-title [title]="isBusinessAccount ? 'Business Address':'Address'"></app-page-title>
    <p
        *ngIf="isBusinessAccount"
        class="highlight"
    ><strong> Please note: </strong> The address below refers to your business account and NOT your client account.</p>
    <p
    *ngIf="isBusinessAccount"
    class="warning"
    ><strong> Important: </strong> The tax rate for your purchase is based on the business account’s shipping address, not the client account’s address. To apply the tax rate based on the client account’s shipping address, log in to the client account to complete your purchase.</p>
    <div
        class="row"
        *ngIf="userOrderAddress.needShippingAddress && !isBusinessAccount"
    >
        <div class="col-md-12 mb-3">
            <div>
                <input
                    type="checkbox"
                    [(ngModel)]="userOrderAddress.areShippingBillingAddressSame"
                />
                Same shipping and billing address
            </div>
        </div>
    </div>

    <div
        class="row"
        *ngIf="countries"
    >
        <div
            *ngIf="userOrderAddress.needShippingAddress"
            class="col-md-5"
        >
            <app-address-form
                [submitted]="submitted"
                [address]="userOrderAddress.shippingAddress"
                [heading]="(userOrderAddress.areShippingBillingAddressSame) ? 'Shipping/Billing Address' : 'Shipping Address'"
                [countries]="countries"
                [isFullNameDisabled]="false"
                (formValueChanged)="shippingFormValueChanged($event)"
            ></app-address-form>
        </div>
        <div
            *ngIf="!(userOrderAddress.needShippingAddress && userOrderAddress.areShippingBillingAddressSame)"
            class="col-md-5"
        >
            <app-address-form
                [submitted]="submitted"
                [address]="userOrderAddress.billingAddress"
                [heading]="'Billing Address'"
                [countries]="countries"
                [isFullNameDisabled]="false"
                (formValueChanged)="billingFormValueChanged($event)"
            ></app-address-form>
        </div>
    </div>
    <br />
    <div class="row">
        <div class="col-md-5">
            <div class="form-group">
                <button
                    (click)="onNextClick()"
                    class="btn btn-primary"
                    type="button"
                >Next</button>
            </div>
        </div>
    </div>
</div>
<app-modal
    #checkoutBusinessAddressModal
    title="{{modalTitle}}"
    body="{{modalBody}}"
>
</app-modal>
